/**
 * On the server, want to aggregate reviews by day, but we want the day to be sensitive to the user's timezone, so we can't rely on server-generated timestamps.
 * @returns The current date in the format YYYY-MM-DD, taking into account eh client's time zone.
 */
export function getClientDay(): string {
  return new Date().toLocaleDateString("en-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}
